import { render, staticRenderFns } from "./submit-confirmation.vue?vue&type=template&id=6f45ec2c&"
import script from "./submit-confirmation.vue?vue&type=script&lang=js&"
export * from "./submit-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports